import React from 'react';
import themeVariables from '~/shared/themeVariables';

const Index = (props) => {
  const { onClickSeeMore } = props;
  return (
    <div className="container-button" onClick={onClickSeeMore}>
      see more
      <style jsx>
        {`
          .container-button {
            background: ${themeVariables.colors.primary};
            display: flex;
            max-width: 113px;
            height: 28px;
            border-radius: 40px;
            justify-content: center;
            align-items: center;
            color: #ffffff;
          }
          .container-button:hover {
            cursor: pointer;
          }
        `}
      </style>
    </div>
  );
};
export default Index;
